import {SortType} from "../../../commons/types/sort.type";
import {DateRangeTemplateType} from "../../../commons/types/date-range-template.type";
import {THREE_PL_SERVICES_SORT_VALUES} from "../constants/threepl-services.constant";

export type ThreePLServicesGroup = "TOTAL" | "UNASSIGNED" | "ASSIGNED" | "STARTED" | "CANCELED" | "COMPLETED" | "RISK";

export interface ThreePLServicesFilters {
  dateRangeTemplateType?: DateRangeTemplateType;
  accountIds?: string[];
  branchIds?: string[];
  supplyAccountIds?: string[];
  serviceAreaIds?: string[];
  depotIds?: string[];
  providerTypes?: string[];
  serviceTypes?: string[];
  programTypes?: string[];
}

export interface ThreePLServicesListQuery {
  from?: number;
  to?: number;
  statusGroup?: string;
  status?: string | string[];
  depotId?: string[];
  accountId?: string[];
  branchId?: string[];
  supplierAccountId?: string | string[];
  areaId?: string[];
  providerType?: string[];
  serviceTypes?: string[];
  programType?: string[];
  searchTerm?: string;
  limit: number;
  sort?: string;
}

export type ThreePLServicesTotals = Record<string, number | undefined>;

export interface ThreePLServicesDynamicColumn {
  key: string;
  title?: string;
  enabled?: boolean;
}

export interface ThreePLServicesSettings {
  defaultGroup?: string;
  columns?: Record<string, boolean>;
  dynamicColumns?: ThreePLServicesDynamicColumn[];
  columnSizes?: Record<string, number>;
  columnOrder?: string[];
}

export type ThreePLServicesTableLayout = Required<Pick<ThreePLServicesSettings, "columnSizes" | "columnOrder">>;

export type ThreePLServicesSortName = "sortEta" | "sortCreatedAt";

export interface ThreePLServicesSortValue {
  name: ThreePLServicesSortName;
  type: SortType;
  value: string;
}

export function nextSortValue(current: ThreePLServicesSortValue | undefined, name: ThreePLServicesSortName): ThreePLServicesSortValue {
  const isSameSortName = !!current && current.name === name;
  const type = isSameSortName && current.type === SortType.asc ? SortType.desc : SortType.asc;
  return {name, type, value: THREE_PL_SERVICES_SORT_VALUES[name][type]};
}

